import React from 'react'
import { useLocation, Navigate, Outlet } from "react-router-dom";
import { useAuthContext } from '../context/AuthContext';

function RequireAuth({ allowedRoles }) {
    const { ctxtUser } = useAuthContext();
    const location = useLocation();
    return (
        allowedRoles?.includes(ctxtUser?.userType) ? <Outlet /> : <Navigate to="/login" state={{ from: location }} replace />
    );
}

export default RequireAuth